exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".help-container .articles-container {\n  margin-top: 20px; }\n", ""]);

// exports
